import CUSTOM_SECTION_CONTAINER_TYPES from '@src/quince-site-common/src/constants/customSectionContainerTypes'
import CUSTOM_SECTION_CONTAINER_NAMES from '@src/quince-site-common/src/constants/customSectionContainerNames'
import { TrackingMetaData } from '@src/quince-site-common/src/domains/CustomSection'

export const TRACKING_METADATA = {
  category: 'complete_the_look',
  action: 'click_complete_the_look',
}

export const getTrackingMetaData = (displayTitle: string): TrackingMetaData => ({
  context: {
    contentContainerType: CUSTOM_SECTION_CONTAINER_TYPES.PRODUCT_DISPLAY,
    contentContainerName: CUSTOM_SECTION_CONTAINER_NAMES.SINGLE_SWIMLANE,
    contentContainerDisplayName: displayTitle,
    trackingId: 'complete_the_look',
  },
})
